import { useEffect } from "react";
import "./App.css";
import Main from "./main/Main";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Switch } from "react-router-dom";
import Education from "./Education/Education";

// IMAGE
// COMPONENTS
import Aboutme from "./aboutme/Aboutme";
import Publication from "./publication/Publication";
import Workexperince from "./workexperience/Workexperince";
import ExtraCurricular from "./ExtraCurricular/ExtraCurricular";
import AccountSetting from "./Account-settings/AccountSetting";
import Certificate from "./certificate/Certificate";
import Project from "./project/Project";
import Navbar from "./navbar/Navbar";
import Signup from "./Login/Signup";
import Login from "./Login/Login";
import Forgotpass from "./Login/Forgotpass";
import Resetpassword from "./Login/Resetpassword";
import VerifyEmailChange from "./Login/VerifyEmailChange";
import CreateBlog from "./posts/CreateBlog";
import CreateQuestion from "./posts/CreateQuestion";
import Blogspreview from "./posts/blogPreview/Blogspreview";
import Questionpreview from "./posts/questionPreview/Questionpreview";
import PostTimeline from "./timeline/PostTimeline";
import Search from "./search/Search";
import PageNotFound from "./Pages/pagenotfound/PageNotFound";
import EditQuestion from "./posts/EditQuestion";
import EditBlogPreview from "./posts/blogPreview/EditBlogPreview";
import EditQuestionPreview from "./posts/questionPreview/EditQuestionPreview";
import { connect } from "react-redux";
import { fetchCategory } from "./services/actions/actions";
import { getCategory } from "./functions/apis";
import Users from "./Pages/user/Users";
import MobileMain from "./Pages/MobileMain";
import MaboutMe from "./aboutme/MaboutMe";
import MobileNotification from "./Mobile/Mobilenotification/MobileNotification";
import Footer from "./Mobile/Mobilefooter/Footer";
// import Resume from "./resume/Resume";
import Resume from './module/resume/pages'
import { useMediaQuery } from 'react-responsive'
import EditResume from "./resume/EditResume";
import Events from "./institute/events/Events";
import AddEvents from "./institute/events/AddEvents";
import Institute from "./institute/Institute";
import ManageUser from "./institute/students/ManageUser";
import Noticies from "./institute/Noticies/Noticies";
import ViewEvents from "./institute/events/ViewEvents";
import ResumePreview from "./resume/Preview/ResumePreview";

import { QueryClient, QueryClientProvider, } from 'react-query'
import Content from "./module/resume/pages/Content";
import Design from "./module/resume/pages/Design";
import ProtectedRoutes from "./Routes/ProtectedRoutes";
const queryClient = new QueryClient()
function App({ fetchCategorys }) {
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1024 })
  const isMobile = useMediaQuery({ maxWidth: 768, minWidth: 320 })
  return (
    <QueryClientProvider client={queryClient}>
    <div className="app">
      <Switch>
        {/* LOGIN & SIGNUP */}
        <Route path="/signup" exact>
          <Signup />
        </Route>
        <Route path="/" exact >
          <Login />
        </Route>
        <Route path="/login" exact>
          <Login />
        </Route>
        <Route path="/forgotpassword" exact>
          <Forgotpass />
        </Route>
        <Route path="/resetpassword" exact>
          <Resetpassword />
        </Route>
        <Route path="/change-email" exact>
          <VerifyEmailChange />
        </Route>
        {/* HOME */}
        <Route path="/user" exact>
          <QueryClientProvider client={queryClient}>
            {/* DESKTOP */}
            <Users mainView={isDesktopOrLaptop && <Aboutme />} />
            {/* MOBILE */}
            <MobileMain mainView={isMobile && <MaboutMe />} />
          </QueryClientProvider>
        </Route>

        {/* INSTITUTE */}
        <Route path="/i/institute" exact>
          {/* DESKTOP */}
          <Users isInstitute mainView={isDesktopOrLaptop && <Institute />} />
          <MobileMain mainView={isMobile && <Institute />} />
        </Route>
        <Route path="/i/institute/events" exact>
          {/* DESKTOP */}
          <Users isInstitute mainView={isDesktopOrLaptop && <Events />} />
          <MobileMain mainView={isMobile && <Events />} />
        </Route>
        <Route path="/i/institute/addevents" exact>
          {/* DESKTOP */}
          <Users isInstitute mainView={isDesktopOrLaptop && <AddEvents />} />
          <MobileMain mainView={isMobile && <AddEvents />} />
        </Route>
        <Route path="/i/institute/manageusers" exact>
          {/* DESKTOP */}
          <Users isInstitute mainView={isDesktopOrLaptop && <ManageUser />} />
          <MobileMain mainView={isMobile && <ManageUser />} />
        </Route>
        <Route path="/i/institute/managenotices" exact>
          {/* DESKTOP */}
          <Users isInstitute mainView={isDesktopOrLaptop && <Noticies />} />
          <MobileMain mainView={isMobile && <Noticies />} />
        </Route>
        <Route path="/i/institute/viewevents/:id" exact>
          {/* DESKTOP */}
          <Users isInstitute mainView={isDesktopOrLaptop && <ViewEvents />} />
          <MobileMain mainView={isMobile && <ViewEvents />} />
        </Route>

        {/* EDUCATION */}
        <Route path="/education" exact>
          <Users mainView={isDesktopOrLaptop && <Education />} />
          <MobileMain mainView={isMobile && <Education />} />
        </Route>
        {/* PUBLICATION */}
        <Route path="/publication" exact>
          <Users mainView={isDesktopOrLaptop && <Publication />} />
          <MobileMain mainView={isMobile && <Publication />} />
        </Route>
        {/* WORK EXPERIENCE */}
        <Route path="/workexperience" exact>
          <Users mainView={isDesktopOrLaptop && <Workexperince />} />
          <MobileMain mainView={isMobile && <Workexperince />} />
        </Route>
        {/* EXTRA CURRICULAR */}
        <Route path="/extracurriculam" exact>
          <Users mainView={isDesktopOrLaptop && <ExtraCurricular />} />
          <MobileMain mainView={isMobile && <ExtraCurricular />} />
        </Route>
        {/* CERTIFICATE */}
        <Route path="/certificate" exact>
          <Users mainView={isDesktopOrLaptop && <Certificate />} />
          <MobileMain mainView={isMobile && <Certificate />} />
        </Route>
        {/* PROJECT */}
        <Route path="/Project" exact>
          <Users mainView={isDesktopOrLaptop && <Project />} />
          <MobileMain mainView={isMobile && <Project />} />
        </Route>
        {/* ACCOUNT SETTING */}
        <Route path="/account" exact>
          <Users mainView={isDesktopOrLaptop && <AccountSetting />} />
          {<MobileMain mainView={isMobile && <AccountSetting />} />}
        </Route>
        {/* CREATE POSTS */}
        <Route path="/createblogs">
          {<Users mainView={isDesktopOrLaptop && <CreateBlog />} />}
          {<MobileMain mainView={isMobile && <CreateBlog />} />}
        </Route>
        <Route path="/editblog/:id">
          <QueryClientProvider client={queryClient}>
            <Users mainView={isDesktopOrLaptop && <CreateBlog isEdit={true} />} />
            <MobileMain mainView={isMobile && <CreateBlog isEdit={true} />} />
          </QueryClientProvider>
        </Route>
        <Route path="/editQuestion/:id">
          <QueryClientProvider client={queryClient}>
            <Users mainView={isDesktopOrLaptop && <EditQuestion isEdit={true} />} />
            <MobileMain mainView={isMobile && <EditQuestion isEdit={true} />} />
          </QueryClientProvider>
        </Route>
        <Route path="/preview_blogs">
          <Navbar />
          <Blogspreview />
        </Route>
        <Route path="/editpreview_blogs">
          <Navbar />
          <EditBlogPreview />
        </Route>
        <Route path="/createquestions">
          {<Users mainView={isDesktopOrLaptop && <CreateQuestion />} />}
          {<MobileMain mainView={isMobile && <CreateQuestion />} />}
        </Route>
        <Route path="/preview_questions">
          <Questionpreview />
        </Route>
        <Route path="/editpreview_questions">
          <EditQuestionPreview />
        </Route>
        <Route path="/posts">
          <Users mainView={isDesktopOrLaptop && <PostTimeline />} />
          <MobileMain mainView={isMobile && <PostTimeline />} />
        </Route>
        {/* SEARCH PAGE */}
        <Route path="/search">
          <Navbar />
          <Search />
        </Route>
        <Route path="/device/notification" exact>
          <MobileNotification />
          <Footer />
        </Route>

        {/* RESUME */}
        {/* <Route path="/createresume/:id/" exact>
          <Navbar />
          <Resume />
        </Route> */}
        <Route path="/resume/preview" exact>
          <Navbar />
          <ResumePreview />
        </Route>
        <Route path="/editresume/:id" exact>
          <Navbar />
          <EditResume />
        </Route>
        <Route path="/resume/content" exact>
          <Navbar />
          <Resume component={<Content/>}/>
        </Route>
        <Route path="/resume/design" exact>
          <Navbar />
          <Resume component={<Design/>}/>
        </Route>

        {/* PAGE NOT FOUND */}
        <Route component={PageNotFound} />
      </Switch>
    </div>
    </QueryClientProvider>
  );
}

const mapDispatchToState = (dispatch) => {
  return {
    fetchCategorys: (value) => {
      dispatch(fetchCategory(value));
    },
  };
};

export default connect(null, mapDispatchToState)(App);
